import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPolygonGeometry,
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import {
    DamType,
    damTypeSchema,
} from 'app/agriculture/queries/entities/types/infrastructure/DamType';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface Dam extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    damType: DamType;

    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export const damSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    damType: damTypeSchema,

    geometry: polygonGeometrySchema,
    pole: pointGeometrySchema,
});

export const mockDam = ({
    id = '52fe491c-fc2a-4aec-8acd-e0195803a444',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Dam Name',
    damType = 'On-Stream',

    geometry = mockPolygonGeometry(),
    pole = mockPointGeometry(),
}: Partial<Dam> = {}): Dam => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    damType,

    geometry,
    pole,
});
